import { Badge } from '@/components/ui/badge';
import { AlertCircle } from 'lucide-react';

interface PromptStatusBadgeProps {
  hasChanges: boolean;
  currentVersion: number | null;
}

export function PromptStatusBadge({ hasChanges, currentVersion }: PromptStatusBadgeProps) {
  if (hasChanges) {
    return (
      <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
        <AlertCircle className="h-3 w-3 mr-1" />
        Alterações não publicadas
      </Badge>
    );
  }

  if (currentVersion) {
    return (
      <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
        Versão {currentVersion}.0 ativa
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="bg-gray-50 text-gray-600">
      Sem versão publicada
    </Badge>
  );
}
